/**
 * Routes: /hilfetexte
 *
 * Will me merged into the router's 'route' array
 */
import Hilfetexte from '@/views/auth/admin/Hilfetexte.vue'
export default [
    {
        path: '/hilfetexte',
        name: 'hilfetexte',
        component: Hilfetexte,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'Hilfetexte',
        },
    },
]
